import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Heading, Image, List, Select, Text, TextInput } from "grommet";
import { debounce } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import { AliasViewModel, searchAliases } from "../aliases/AliasStore";
import { NavigationButton } from "../components/NavigationButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import MapDetails from "./MapDetails";
import { getMap, MapViewModel, updateMap, UpdateMapRequest } from "./MapsStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;

const MapProfile = () => {
    let { id } = useParams<{ id: string }>();

    let { pathname } = useLocation();
    let navigate = useNavigate();

    React.useEffect(() => {
        if (!pathname.endsWith("/")) {
            navigate("details", { replace: true });
        }
    }, [pathname]);

    React.useEffect(() => {
        fetchMap();
    }, []);

    const [map, setMap] = React.useState({} as MapViewModel | UpdateMapRequest);
    const [isLoading, setIsLoading] = React.useState(true);

    let [error, setError] = React.useState("");

    const fetchMap = () => {
        return getMap(id).then((result) => {
            if (result.status == 200) {
                setMap(result.data.result);
            } else {
                setMap({} as MapViewModel);
            }
            setIsLoading(false);
        });
    };

    const [isUpdating, setIsUpdating] = React.useState(false);

    const onChange = (updatedMap) => {
        setMap({ ...map, ...updatedMap });
    };

    let update = () => {
        setIsUpdating(true);
        updateMap(map).then(
            (result) => {
                fetchMap().then((map) => {
                    setIsUpdating(false);
                });
            },
            (error) => {
                setError(error);
                setIsUpdating(false);
            }
        );
    };

    const hasWritePermission = usePermission("sport:maps.write");

    return (
        <div>
            <SkeletonWrapper loading={isLoading}>
                <Heading size="small">
                    <Box direction="row" align="center" gap="small">
                        <Image src={map.logoUri + "?ts=" + Math.random()} alt="" style={{ height: "auto", maxWidth: "80px", width: "auto", maxHeight: "80px", objectFit: "contain" }} />
                        {map.name}
                    </Box>
                </Heading>

                <Box direction="row" align="center" justify="center" gap="medium">
                    <NavigationButton href={`details`} text={"Details"}></NavigationButton>
                    {error && <NavigationButton href={`error`} text={"Errors"}></NavigationButton>}
                </Box>

                <Routes>
                    <Route
                        path="details"
                        element={
                            <>
                                <MapDetails map={map} isBusy={!hasWritePermission || isUpdating} onChange={onChange}></MapDetails>
                                <br />
                                {hasWritePermission && (
                                    <>
                                        {/* @ts-ignore */}
                                        <Button primary onClick={update} disabled={isUpdating || !map.name} label="Update"></Button>
                                    </>
                                )}
                            </>
                        }
                    />
                    <Route
                        path="home"
                        element={
                            <>
                                <Button href={"/ue/maps/" + map.id} icon={idBadge} label="View Home Page"></Button>
                            </>
                        }
                    />
                    <Route
                        path="error"
                        element={
                            <>
                                <pre>{JSON.stringify(error, null, 2)}</pre>
                            </>
                        }
                    />
                </Routes>
            </SkeletonWrapper>
        </div>
    );
};

export default MapProfile;
